import { ScoreCardResultsService } from 'api-clients/monolith/services/ScoreCardResultsService';
import { useCallback } from 'react';

import { useApiService } from 'hooks/useApiService';

export const useScorecardResultContext = (
  templateId: number,
  applicantId: string,
) => {
  const fetchContext = useCallback(
    () =>
      ScoreCardResultsService.getInternalApiScoreCardsTemplatesApplicantsResult(
        templateId,
        applicantId,
      ),
    [templateId, applicantId],
  );

  return useApiService(fetchContext, {
    enabled: Number.isFinite(templateId) && Boolean(applicantId),
  });
};
